import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const CustomerPoNumberCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer PO #",
    cell: (row) =>
      row.orders.map((order) => order.secondaryOrderName).join(", ") || "",
  };
